export const lang = {
    menu:{
        Home:"Home",
        Class:'Class',
        ShoppingCart:'ShoppingCart',
        My:'My'
    },
    my:{
        MyOrder:'MyOrder',
        AllOrders:'AllOrders',
        PrePayment:'PrePayment',
        Delivery:'Delivery',
        Receipt:'Receipt',
        Estimate:'Estimate',
        CouponCenter:'CouponCenter',
        MyAddress:'MyAddress',
        MyDiscountCoupon:'MyDiscountCoupon',
        MyBargain:'MyBargain',
        MyScores:'MyScores',
        HelpCenter:'HelpCenter',
        DistributionCenter:'DistributionCenter',
        DropOut:'DropOut',
        TermsofUse:'TermsofUse',
        MyCreditCard:'MyCreditCard'
    },
    clause:{
        ReturningProvisions:'ReturningProvisions',
        PaymentMethod:'PaymentMethod',
        PrivacyPolicy:'PrivacyPolicy',
        MailingInformation:'MailingInformation',
        TermsOfUse:'TermsOfUse',
    },
    other:{
        Settlement:"Settlement",
    },
    //订单结算
    OrderSettlement:{
        CourierDelivery:'CourierDelivery',
        PickItUpAtHome:'PickItUpAtHome',
        PriceOfCommodities:'PriceOfCommodities',
        Coupon:'Coupon',
        DeliveryFee:'DeliveryFee',
        PromoCode:'PromoCode',
        ACombined:'ACombined',
        ModeOfPayment:'ModeOfPayment',
        ActualPayment:'ActualPayment',
        ConfirmPayment:'ConfirmPayment',
        CreditCardPayment:'CreditCardPayment'
    },
    //商品详情
    goodsShow:{
        ImmediatePurchase:'Buy',
        AddToCart:'AddToCart',
        HomePage:'Home',
        TheShoppingCart:'ShoppingCart',
    },
}
